// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__imiM2","buttons":"RemoveExpirationActionButtons_buttons__3H5VL"};